const submitTextSignupForm = (phoneNumber) => {
	$.ajax({
		url: '/wcs/resources/store/301/account/textsignup',
		cache: false,
		type: 'POST',
		data: JSON.stringify({phone: phoneNumber}),
		dataType: "json",
        headers: { "Content-Type": "application/json" },
		success: function (json) {
			$('#textSignupSuccessMessage').show();
			$('#recipientText').val('');
			$('#textSignupDisclaimer').hide();
		},
		error: function (json) {
			$('#textSignupErrorMessage').show();
			$('#textSignupDisclaimer').hide();
		},
	});
};


const ajaxTextSignup = (params, returnHTML) => {
    var $form = $('#' + params.formId);
    var phoneNumber = $form.find("input[name*='recipientText']").val();

	let html = `<div id=textSignupModal>
					<div id="textSignupDisclaimer">
						<p class="textSignupCopy">By submitting this form you agree to receive recurring automated promotional and personalized marketing text messages (e.g. cart reminders) from Dillard's
						at the cell number used when signing up. Consent is not a condition of any purchase. Reply <strong>HELP</strong> for help and <strong>STOP</strong> to cancel.
						Msg frequency varies. Msg & data rates may apply.<br>View <a href="http://attn.tv/dillards/terms.html" target="_blank">Terms</a> & <a href="https://attnl.tv/p/vHU" target="_blank">Privacy</a></p>
						<br>
						<div class="modal-footer">
							<button type="button" class="btn btn-primary prevent-double-click-hack-for-ibm-cookie-problem" onclick="$(Dillards.submitTextSignupForm(` + phoneNumber + `));">SUBMIT</button>
							<button type="button" class="btn btn-secondary" data-dismiss="modal">CANCEL</button>        
						</div>
					</div>
					<div id="textSignupSuccessMessage">
						<div class="successTitle">Congratulations!</div>
						<p class="textSignupCopy">
							And <b>thank you</b> for sharing your number with us. You'll be the first to hear about new products, great offers, and upcoming sales via text.
						</p>
					</div>
					<div id="textSignupErrorMessage">
						<div class="errorTitle">Something went wrong.</div>
						<p class="textSignupCopy">
							Please close this window, verify that the number you have entered is valid, and try submitting your mobile phone number again.
						</p>
					</div>
				</div>`
	returnHTML(html);
};

export { submitTextSignupForm, ajaxTextSignup };
